module.exports = __webpack_public_path__ + "img/userimg.d570ddd5.png";